import getAxiosInstance from '../../../helpers/get_axios_instance'
import { OK } from 'http-status-codes'

export class TablaDistribucionPorCerealService {
  static async getDataTablaDistribucionPorCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion de cereales.')
      return (data)
    })
  }

  static async getDataTablaDistribucionPorCerealTotal () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion de cereales.')
      return (data)
    })
  }
}
